import React from 'react'
import Grid from '@material-ui/core/Grid'
import MenuList from '@material-ui/core/MenuList'
import withStyles from '@material-ui/core/styles/withStyles'
import { EventMenuItems } from '../containers'
import { EventListCard, EventCard } from '../containers'
import { TitleGrid } from '../../../containers'

const styles = theme => ({
})

class EventHome extends React.Component {  
  render() {
    const { theme, width, isMounted, language } = this.props
    var gridProp, titleGridProp
    gridProp = width < theme.breakpoints.values.md ? { xs: 12 } : { xs: 9 }
    titleGridProp = width < theme.breakpoints.values.md ? { menuItems : (<EventMenuItems/>) } : undefined
    
    if (this.props.match.params.eventId === undefined) {
      return (
        <TitleGrid spacing={16} titleType='event' {...titleGridProp} key={'list'}>
          {width >= theme.breakpoints.values.md && (
            <Grid item xs={12} md={3}>
              <MenuList>
                <EventMenuItems/>
              </MenuList>
            </Grid>
          )}
          <Grid item {...gridProp}>
            <EventListCard grid language={language}/>
          </Grid>
        </TitleGrid>
      )
    }
    else {
      return (
        <TitleGrid spacing={16} titleType='event' {...titleGridProp} key={'event'}>
          {width >= theme.breakpoints.values.md && (
            <Grid item md={3}>
              <MenuList>
                <EventMenuItems/>
              </MenuList>
            </Grid>
          )}
          <Grid item md={6} xs={12}>
            <EventCard
              eventId={this.props.match.params.eventId}
              key={this.props.match.params.eventId}
            />
          </Grid>
          {Boolean(width >= theme.breakpoints.values.md || isMounted) && (
          <Grid item md={3} xs={12}>
            <EventListCard fullWidth/>
          </Grid>
          )}
        </TitleGrid>
      )
    }
  }
}

export default withStyles(styles, { withTheme: true })(EventHome)



// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventHome.js